import {DeterminantRow} from "./determinant-row";

export class TabRow extends DeterminantRow {
  public label: string;
  public workingLabel: string;
  public key: string;
  public group: string;
  public hidden?: boolean;
  public titleMode: string = "label";
  public iconPosition: string = "left";
  public icon?: string;
  public hasTopSeparator?: boolean;

  constructor(label: string, key: string) {
    super();
    this.label = label;
    this.key = key;
  }
}
